/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ConsentContextOutAction = typeof ConsentContextOutAction[keyof typeof ConsentContextOutAction];


export const ConsentContextOutAction = {
  consent: 'consent',
  decline: 'decline',
} as const;
